<template>
  <v-dialog v-model="dialog" width="75vw" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom v-bind="attrs" v-on="on">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-btn text x-small v-on="on" @click.stop="dialog = true">
              <v-icon small>{{
                noFiles ? "mdi-folder-open-outline" : "mdi-folder-open"
              }}</v-icon>
            </v-btn>
          </span>
        </template>
        <span> View Files </span>
      </v-tooltip>
    </template>

    <v-card v-if="dialog" :scrollable="false">
      <v-card-title>
        {{ appointment.idepClientId }}: {{ appointment.fullName }} -
        {{ appointment.formattedAppointmentDate }}
        <v-toolbar flat>
          <upload-file-button
            title="Upload File(s)"
            @uploadFiles="uploadFiles"
          ></upload-file-button>
        </v-toolbar>
        <v-spacer></v-spacer>
        <v-btn icon @click="clear">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <v-data-table
              :headers="headers"
              :items="appointment.files"
              hide-default-header
              hide-default-footer
              no-data-text=""
              item-key="fileId"
              @click:row="loadFile"
              style="cursor: pointer"
              :item-class="highlightSelectedRow"
              :key="appointment.files.length"
            >
            </v-data-table>
          </v-col>
          <v-col cols="12" sm="8">
            <file-viewer :noFiles="noFiles" ref="fileViewerRef"></file-viewer>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import UploadFileButton from "../Shared/upload-file-button.vue";
import FileViewer from "../Shared/file-viewer.vue";
export default {
  components: {
    UploadFileButton,
    FileViewer,
  },
  props: ["appointmentId"],
  data() {
    return {
      dialog: false,
      headers: [{ text: "File", value: "fileName" }],
      selected: null,
    };
  },
  computed: {
    appointment() {
      return this.$store.getters["appointmentsModule/getAppointmentById"](
        this.appointmentId
      );
    },
    noFiles() {
      return this.appointment.files.length === 0;
    },
  },
  methods: {
    async loadFile(item) {
      this.selected = item;
      this.$refs.fileViewerRef.loadFile(item);
    },
    highlightSelectedRow(row) {
      return this.selected?.fileId === row.fileId && "selectedRow";
    },
    // this calls a callback when done
    async uploadFiles(value, done) {
      this.loading = true;
      await this.$store.dispatch("appointmentsModule/uploadFiles", {
        mtaAppointmentId: this.appointment.mtaAppointmentId,
        files: value,
      });
      this.loading = false;

      done();
    },
    clear() {
      this.selected = null;
      this.dialog = false;
    },
  },
};
</script>

<style lang="css">
.selectedRow {
  background: #ccc;
}
</style>
